import { Avatar, AvatarFallback, AvatarImage } from '@app/components/ui/avatar';
import { useInitials } from '@app/hooks/use-initials';
import { type User } from '@app/types';

export function UserInfo({ user, showEmail = false }: { user: User; showEmail?: boolean }) {
    const getInitials = useInitials();
    const displayName = user.name ?? user.email;

    return (
        <>
            <Avatar className="h-8 w-8 overflow-hidden rounded-full">
                <AvatarImage src={undefined} alt={displayName} />
                <AvatarFallback className="rounded-lg bg-muted text-foreground">
                    {getInitials(displayName)}
                </AvatarFallback>
            </Avatar>
            <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-medium">{displayName}</span>
                {showEmail && <span className="text-muted-foreground truncate text-xs">{user.email}</span>}
            </div>
        </>
    );
}
